import { useState } from "react";
import { timeReflections } from "@/mocks/quotes";

export default function TimeReflections() {
  const [openId, setOpenId] = useState<string | null>(timeReflections[0]?.id ?? null);

  return (
    <section id="reflections" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-16">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-xs tracking-widest text-primary-600 uppercase">Reflections</span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            时光感悟：把心事慢慢讲清楚
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            这里不只是短句。选一个你此刻最接近的时段，展开读一段完整的感悟，
            它更长、更慢，也更接近一个人在深夜里想说的话。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-4">
          {timeReflections.map((item) => {
            const isOpen = openId === item.id;
            return (
              <article
                key={item.id}
                className={`rounded-lg border transition-colors ${
                  isOpen
                    ? "bg-background-100 border-primary-200"
                    : "bg-background-100/60 border-background-200/70 hover:border-background-300"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : item.id)}
                  aria-expanded={isOpen}
                  className="w-full flex items-start gap-4 md:gap-6 text-left p-5 md:p-7 cursor-pointer"
                >
                  <span className="shrink-0 flex flex-col items-center gap-2">
                    <span
                      className={`w-10 h-10 flex items-center justify-center rounded-full ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className="ri-time-line"></i>
                    </span>
                    <span className="hidden md:block w-px h-full min-h-[8px] bg-background-300" aria-hidden="true"></span>
                  </span>

                  <span className="flex-1 min-w-0">
                    <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs">
                      {item.period}
                    </span>
                    <h3 className="mt-3 font-heading text-lg md:text-xl font-semibold text-foreground-950 leading-snug">
                      {item.title}
                    </h3>
                    <span className="mt-3 block text-sm leading-relaxed text-foreground-600">
                      {item.lead}
                    </span>
                  </span>

                  <span
                    className={`shrink-0 w-9 h-9 flex items-center justify-center rounded-md border text-foreground-600 transition-transform ${
                      isOpen ? "rotate-180 border-primary-300 text-primary-700" : "border-background-300"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>

                <div className={isOpen ? "block" : "hidden"}>
                  <div className="px-5 md:px-7 pb-7 pl-[4.5rem] md:pl-[5.5rem]">
                    <div className="pt-1 border-t border-background-200/70 flex flex-col gap-4 pt-5">
                      {item.body.map((para, i) => (
                        <p key={i} className="text-sm md:text-base leading-loose text-foreground-800">
                          {para}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}